import Button, { ButtonProps } from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import { useCallback, useMemo, useState } from 'react'
import styles from './LoginButton.pcss'

const LOADER_SIZE = 24
export const LOGIN_BTN_ID = 'btn-login'

export interface LoginButtonProps {
  buttonClassName: string
  progressClassName: string
  className?: string
  initialized: boolean
  displayInitialized: string
  text?: boolean
  onLogin: () => Promise<any>
}

export function LoginButton(props: LoginButtonProps) {
  const [loading, setLoading] = useState(false)

  const onLogin = useCallback(() => {
    setLoading(true)
    props.onLogin()
      .then(() => {
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
    return false
  }, [props])

  const enabled = !loading && props.initialized

  const activeButtonProps: ButtonProps = useMemo(() => ({
    key: 'primary',
    id: LOGIN_BTN_ID,
    variant: 'contained',
    onClick: onLogin,
    classes: {
      root: `${props.buttonClassName} ${props.className || ''} ${styles.button}`
    }
  }), [props.buttonClassName, props.className, onLogin])

  const disabledButtonProps: ButtonProps = useMemo(() => ({
    ...activeButtonProps,
    disabled: true,
    className: styles['btn-loading'],
    classes: {
      root: `${activeButtonProps?.classes?.root} ${styles.disabled} ${styles.button}`
    }
  }), [activeButtonProps])

  if (props.text) {
    return (
      <a
        className={`${styles['btn-text']} ${enabled ? '' : styles.disabled} ${props.className || ''}`}
        onClick={onLogin}
      >
        {props.displayInitialized}
      </a>
    )
  }

  if (enabled) {
    return (
      <Button {...activeButtonProps} onClick={onLogin}>
        {props.displayInitialized}
      </Button>
    )
  }

  return (
    <Button {...disabledButtonProps}>
      <CircularProgress className={props.progressClassName} size={LOADER_SIZE} />
    </Button>
  )
}

export default LoginButton
